<template>
  <b-form v-if="etapaCargada" @submit.stop.prevent class="row col-12 mx-auto">
    <b-col
      cols="24"
      md="24"
      lg="12"
      sm="24"
      order-md="0"
      class="text-center mb-0"
    >
      <div class="banner">
        <p class="banner-text">
          Periodo Principal de postulación para
          <strong style="font-size: 1.2em;"
            >el año escolar {{ anioAdmision }}</strong
          >
        </p>
      </div>
    </b-col>

    <InformacionRegistro v-if="etapaProceso === 'REGISTRO'" />
    <InformacionPostulacion v-if="etapaProceso === 'POSTULACION'" />
    <InformacionPostulacionRegistroAnticipado
      v-if="etapaProceso === 'REGISTRO_ANTICIPADO'"
    />
    <InformacionResultados v-if="etapaProceso === 'NORMAL'" />
    <InformacionListaDeEspera v-if="etapaProceso === 'LISTA_DE_ESPERA'" />
    <InformacionPostulacionComplementaria
      v-if="etapaProceso === 'COMPLEMENTARIO'"
    />
    <InformacionResultadosFinales v-if="etapaProceso === 'RESULTADO_FINAL'" />

    <b-col cols="12" md="12" lg="6" sm="12" order-md="1">
      <div
        class="text-azul-medio text-uppercase gilmer h5 bg-white mx-0 pt-0 pb-0 font-weight-bold mb-0"
      >
        <span v-if="titulo" v-text="titulo" />
        <span v-else>&nbsp;</span>
      </div>
      <InicioRegistro v-if="etapaProceso === 'REGISTRO'" />
      <template v-else>
        <div
          class="h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3"
          v-if="
            !['NORMAL', 'LISTA_DE_ESPERA', 'RESULTADO_FINAL'].includes(
              etapaProceso
            )
          "
        >
          <div class="gilmer text-uppercase h5 mx-4 mx-lg-5 mt-4">
            <b>REGISTRO COMO APODERADO(A)</b>
          </div>
          <div class="form-group mx-4 mt-4 text-justify m-1 h5">
            <span>
              Si tienes RUN y no has postulado en años anteriores crea una nueva
              cuenta con tu carnet de identidad, correo electrónico y teléfono.
            </span>
          </div>
          <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
            <router-link
              data-testid="button-olvido-contrasena"
              to="registro"
              class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
              theme="light"
              type="submit"
              >REGISTRARME</router-link
            >
          </div>
          <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
            <p class="italic-text">
              Si no tienes RUN chileno, obtén tu Identificador provisorio de
              apoderado(a)
              <a
                href="https://ayudamineduc.cl/tramites-en-linea"
                target="_blank"
                style="text-decoration: underline;"
              >
                aquí </a
              >.
              <br />
            </p>
          </div>
        </div>

        <div
          class="h6 text-center rounded text-white px-0 bg-azul-medio w-100 py-3 contentHeight"
        >
          <div class="gilmer text-uppercase h5">
            <span
              v-if="
                ['NORMAL', 'LISTA_DE_ESPERA', 'RESULTADO_FINAL'].includes(
                  etapaProceso
                )
              "
              >Ingresa para revisar tus resultados</span
            >
            <span v-else-if="['REGISTRO_ANTICIPADO'].includes(etapaProceso)">
              <b>Ingreso de apoderado(a) con cuenta ya registrada.</b>
            </span>
            <span v-else>Ingresa para postular</span>
          </div>
          <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
            <label for="run" class="mb-1">RUN/IPA apoderado</label>
            <b-input
              data-testid="run"
              v-model="rut"
              id="run"
              type="text"
              class="form-control form-control-lg placeholder"
              placeholder="21.123.456-1"
              :state="tieneError('rut')"
              @keyup.once="modificado.push('rut')"
              @change="validarRut"
              @keyup="formatoRut"
              maxlength="13"
              autocomplete="off"
            />
            <div class="mensaje-error" v-show="errorRut">
              {{ this.mensajeError("rut") }}
            </div>
          </div>
          <div class="form-group mx-4 mx-lg-5 mt-4 text-left">
            <label for="password" class="mb-1">Contraseña</label>
            <b-input
              data-testid="clave"
              v-model="usuario.clave"
              id="password"
              type="password"
              class="form-control form-control-lg placeholder"
              placeholder="Contraseña"
              :state="this.tieneError('pass')"
              @keyup.once="modificado.push('pass')"
              @change="validarPassword('pass', usuario.clave)"
              autocomplete="off"
            />
            <div class="mensaje-error" v-show="errorPass">
              {{ this.mensajeError("pass") }}
            </div>
          </div>

          <div class="d-block mx-4 mx-lg-5 mt-3 mb-4">
            <InvisibleRecaptcha
              v-if="captchaHabilitado"
              data-test="button-login-captcha"
              id="logincapcha"
              :sitekey="siteKey"
              :validate="validarCredenciales"
              :callback="captcha"
              theme="light"
              class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
              type="submit"
              >Ingresar</InvisibleRecaptcha
            >

            <button
              v-if="!captchaHabilitado"
              class="btn-lg btn-azul-oscuro2 text-uppercase gilmer font-weight-bold w-100"
              data-testid="button-login"
              id="login"
              type="submit"
              @click.prevent="pruebaAutomatizada"
            >
              Ingresar
            </button>
            <div>
              <p class="italic-text mt-1 texto_lefted">
                Si tienes un Identificador Provisorio de Apoderado (IPA) la
                contraseña será el número de IPA sin puntos ni dígito
                verificador. Por ejemplo si el IPA es 200.123.456-7, la
                contraseña será 200123456.
              </p>
            </div>
            <router-link
              data-testid="button-olvido-contrasena"
              to="olvido-contrasena"
              class="font-weight-bold text-white subrayado"
              >Olvid&eacute; mi contrase&ntilde;a.</router-link
            >
          </div>
          <div class="w-100 texto-centro" v-if="claveunica">
            <span
              style="display: block; margin: 30px 5px; font-family: sans-serif;"
              >Si ya tienes cuenta, recuerda que puedes ingresar con clave
              única</span
            >
            <!-- Estructura base de botón -->
            <a @click="cargarClaveUnica" class="btn-cu">
              <span class="cl-claveunica"></span>
              <span class="texto">Iniciar sesión</span>
            </a>
            <!-- fin estructura base de botón -->
          </div>
        </div>
      </template>
    </b-col>
  </b-form>
</template>

<script>
import ApiLogin from "@/services/ApiLogin";
import ApiDirectorio from "@/services/ApiDirectorio";
import ApiClaveUnica from "@/services/ApiClaveUnica";
import { manejoErrores } from "@/assets/js/manejoErrores";
import Validador from "@/assets/js/validador";
import FormateaRut from "@/assets/js/formatoRut";
import InvisibleRecaptcha from "@/components/generales/recaptcha/InvisibleRecaptcha";
import { faRoute } from "@fortawesome/free-solid-svg-icons";
import InformacionPostulacion from "@/components/login/InformacionPostulacion";
import InformacionPostulacionRegistroAnticipado from "@/components/login/InformacionPostulacionRegistroAnticipado";
import InformacionResultados from "@/components/login/InformacionResultados";
import InformacionListaDeEspera from "@/components/login/InformacionListaDeEspera";
import InformacionPostulacionComplementaria from "@/components/login/InformacionPostulacionComplementaria";
import InformacionResultadosFinales from "@/components/login/InformacionResultadosFinales";
import InformacionRegistro from "@/components/login/InformacionRegistro";
import InicioRegistro from "@/components/Inicio/InicioRegistro";
export default {
  mixins: [manejoErrores],
  components: {
    InvisibleRecaptcha,
    InformacionPostulacion,
    InformacionPostulacionRegistroAnticipado,
    InformacionResultados,
    InformacionListaDeEspera,
    InformacionPostulacionComplementaria,
    InformacionResultadosFinales,
    InformacionRegistro,
    InicioRegistro
  },
  data() {
    return {
      usuario: {
        run: "",
        clave: ""
      },
      config: {
        headers: {},
        params: {}
      },
      siteKey: RECAPTCHA_PUBLIC_KEY,
      rut: "",
      errorRut: false,
      errorPass: false,
      tiempoToken: 15 * 60 * 1000,
      ayuda: PLATAFORMA.AYUDA,
      etapaProceso: null,
      captchaHabilitado: localStorage.getItem("recatpchaHabilitado") || "true",
      claveunica: CLAVE_UNICA_HABILITADO,
      anioAdmision: localStorage.getItem("anioAdmision") || "2026",
      etapaCargada: false,
      intervalId: null,
      previousValue: localStorage.getItem("etapaProceso")
    };
  },
  mounted() {
    this.intervalId = setInterval(() => {
      const currentValue = localStorage.getItem("etapaProceso");
      if (currentValue !== this.previousValue) {
        window.location.reload();
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  created() {
    this.obtieneParametros();
  },
  computed: {
    titulo() {
      switch (this.etapaProceso) {
        case "POSTULACION":
          "Realiza tu postulación";
          break;
        case "COMPLEMENTARIO":
          return "PERIODO COMPLEMENTARIO";
          break;
        default:
          break;
      }
    }
  },
  methods: {
    async obtieneParametros() {
      try {
        const tokenBearer =
          "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJhZG1pc2lvbi1lc2NvbGFyIiwiaWF0IjoxNzQ4ODgxNDE0LCJleHAiOjE3ODA0MTc0MTQsImlkUG9zdHVsYWNpb24iOiI2ODNkYmZhODhiYmZmMzAwMDE5YWY1ZmYiLCJpc0FkbWluIjpmYWxzZX0.3AztlB-nsLnr-Pe2-mzyo3gzRaEAowUZq2-VeumajHE";
        const etapaValor = await ApiDirectorio.obtenerInformacion(
          this,
          tokenBearer
        );
        if (etapaValor.resultadoEtapa) {
          this.etapaCargada = true;
          localStorage.setItem("etapaProceso", etapaValor.resultadoEtapa);
          localStorage.setItem(
            "anioSiguiente",
            etapaValor.parametroAnioSiguiente.valor
          );
          localStorage.setItem(
            "anioAnterior",
            etapaValor.parametroAnioAnterior.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesempenioBasica",
            etapaValor.parametroAnioIndicadorCatDesempenioBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesempenioMedia",
            etapaValor.parametroAnioIndicadorCatDesempenioMedia.valor
          );
          localStorage.setItem(
            "anioIndicadorCatSimceBasica",
            etapaValor.parametroAnioIndicadorCatSimceBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatSimceMedia",
            etapaValor.parametroAnioIndicadorCatSimceMedia.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesarrolloBasica",
            etapaValor.parametroAnioIndicadorCatDesarrolloBasica.valor
          );
          localStorage.setItem(
            "anioIndicadorCatDesarrolloMedia",
            etapaValor.parametroAnioIndicadorCatDesarrolloMedia.valor
          );
          localStorage.setItem(
            "mostrarVacantes",
            etapaValor.parametroMostrarVacantes.valor
          );
          localStorage.setItem(
            "mostrarProcedimientosEspeciales",
            etapaValor.parametroMostrarProcedimientosEspeciales.valor
          );
          localStorage.setItem(
            "modoEnvioCorreo",
            etapaValor.parametroModoEnvioCorreo.valor
          );
          localStorage.setItem(
            "anioPostulacion",
            etapaValor.parametroAnioPostulacion.valor
          );
          localStorage.setItem(
            "anioAdmision",
            etapaValor.parametroAnioAdmision.valor
          );
          localStorage.setItem(
            "inicioPostulacion",
            etapaValor.parametroInicioPostulacion.valor
          );
          localStorage.setItem(
            "finPostulacion",
            etapaValor.parametroFinPostulacion.valor
          );
          localStorage.setItem(
            "fechaListaEspera",
            etapaValor.parametroFechaListaEspera.valor
          );
          localStorage.setItem(
            "fechaPeriodoComplementario",
            etapaValor.parametroFechaPeriodoComplementario.valor
          );
          localStorage.setItem(
            "fechaResultadosFinales",
            etapaValor.parametroFechaResultadosFinales.valor
          );
          localStorage.setItem(
            "modoRecuperarPassword",
            etapaValor.parametroModoRecuperarPassword.valor
          );
          localStorage.setItem(
            "recaptchaHabilitado",
            etapaValor.parametroRecaptchaHabilitado.valor
          );
          this.etapaProceso = etapaValor.resultadoEtapa;
        } else {
          console.error("No se obtuvo la etapa correctamente.");
        }
      } catch (error) {
        console.error("Error al cargar la etapa:", error);
      }
    },

    //ELIMINAR ANTES DE PRODUCCION
    async pruebaAutomatizada() {
      let formValido = this.validarCredenciales();
      if (formValido) {
        this.config.headers = {
          "g-recaptcha-response": "recaptchaToken"
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        await this.loguear();
      }
      this.emitCargado();
    },
    //ELIMINAR ANTES DE PRODUCCION
    async captcha(recaptchaToken) {
      if (recaptchaToken) {
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.config.params = {
          tipoCaptcha: "INVISIBLE"
        };
        await this.loguear();
      }
      this.emitCargado();
    },
    emitCargar() {
      this.$emit("cargar");
    },
    emitCargado() {
      this.$emit("cargado");
    },
    validarCredenciales() {
      this.emitCargar();
      this.modificado = ["rut", "pass"];
      let valido = [this.validarRut(), this.validarPassword()];
      let validado = true;
      if (valido.includes(false)) {
        validado = false;
        this.emitCargado();
      }

      return validado;
    },
    formatoRut() {
      this.rut = FormateaRut.formateaRut(this.rut);
    },
    validarRut() {
      let valido = true;
      let valor = this.rut;
      let campo = "rut";
      this.limpiarError(campo);
      this.errorRut = false;
      if (valor.length < 1) {
        this.guardarError(campo, "Ingrese su RUN.");
        valido = false;
      } else if (
        !Validador.validarExpresion("rut", valor) ||
        !FormateaRut.digitoVerificador(valor)
      ) {
        this.guardarError(campo, "El Run no es válido");
        valido = false;
      }
      if (valido) {
        this.usuario.run = parseInt(
          valor
            .slice(0, -1)
            .split(".")
            .join("")
            .replace("-", "")
        );
      } else {
        this.errorRut = true;
      }
      return valido;
    },
    validarPassword() {
      let valido = true;
      let errores = [];
      let campo = "pass";
      let valor = this.usuario.clave;
      this.limpiarError(campo);
      this.errorPass = false;
      if (valor.length < 1) {
        errores.push("Ingrese su contraseña");
      } else if (valor.length < 8) {
        errores.push("Contraseña no válida");
      }
      if (errores.length > 0) {
        this.guardarError(campo, errores[0]);
        this.errorPass = true;
        valido = false;
      }
      return valido;
    },
    //TODO: Revisar que el jwt se mantenga en el sessionstorage, porque cuando se cambia de dominio se pierde
    async loguear() {
      this.$emit("cargar");
      let loguear = await ApiLogin.loguearUsuario(
        this.usuario,
        this,
        this.config
      );
      if (loguear) {
        this.$ss.set("jwt", loguear.token, this.tiempoToken);
        this.$ss.set("esClaveSegura", loguear.esClaveSegura, this.tiempoToken);

        if (this.$ss.get("jwt", "") === "") {
          this.$ss.set("jwt", loguear, this.tiempoToken);
        }
        if (
          this.etapaProceso === "POSTULACION" ||
          this.etapaProceso === "COMPLEMENTARIO" ||
          this.etapaProceso === "REGISTRO_ANTICIPADO"
        ) {
          this.$router.push({ name: "Postulacion" });
        } else if (
          this.etapaProceso === "NORMAL" ||
          this.etapaProceso === "LISTA_DE_ESPERA" ||
          this.etapaProceso === "RESULTADO_FINAL"
        ) {
          this.$router.push({ name: "Resultados" });
        }
      } else {
        this.usuario.run = "";
        this.rut = "";
        this.usuario.clave = "";
        this.$emit("cargado");
      }
    },
    async cargarClaveUnica() {
      this.$emit("cargar clave unica");
      let loguear = await ApiClaveUnica.loginClaveUnica();
    }
  }
};
</script>
<style>
/*
	BTN Clave Única.
	Estilos gráficos para el botón de clave única.
	V 1.0.0
*/

.btn-cu {
  display: inline-block;
  padding: 8px 18px 8px 15px !important;
  background-color: #0f69c4;
  font-family: Roboto, sans-serif;
  font-size: 1em;
  line-height: 1.6em;
  color: #fff !important;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 0;
  cursor: pointer;
}

.btn-cu .cl-claveunica {
  color: #fff !important;
  display: inline-block;
  float: left;
  text-indent: -9999px;
  width: 24px;
  height: 24px;
  background: url("https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/claveunica.svg");
  background-size: 24px 24px;
}

.banner {
  background-color: #2e3192; /* Cambia el color del banner según tus necesidades */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2rem;
}

.btn-cu .texto {
  padding-left: 3px;
  color: #fff !important;
  text-decoration: underline;
}

.btn-cu:hover {
  background-color: #2e3192;
}

.btn-cu:hover.hover-shw {
  background-color: #0f69c4 !important;
  -webkit-box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.2);
}

.btn-cu.s {
  padding: 6px 14px 6px 12px !important;
  font-size: 0.8rem;
}

.btn-cu.s .cl-claveunica {
  width: 18px;
  height: 18px;
  background-size: 18px 18px;
}

.btn-cu.l {
  padding: 11px 30px 11px 23px !important;
  font-size: 1.25rem;
}

.btn-cu.l .cl-claveunica {
  width: 32px;
  height: 32px;
  background-size: 32px 32px;
}
</style>
<style scoped>
.mensaje-error {
  margin-top: -3px;
  padding: 0.5rem 1rem;
  background-color: #f7edeb;
  color: #dc3545 !important;
  border: 1px solid #dc3545 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
a,
a:hover {
  color: white;
}

label {
  cursor: inherit;
}
</style>



// WEBPACK FOOTER //
// src/pages/Inicio.vue